/**
 * Die Google-Attribution unter (oder neben) Angaben aus Google Places — R4.5, Konzept § 6.2.
 *
 * Diese Datei enthaelt ABSICHTLICH keine Entscheidung: ob die Zeile erscheint, entscheidet
 * `googleAttribution()` aus `@maestro/google-attribution` anhand der uebergebenen Werte. `apps/web`
 * hat keinen Test-Runner — eine Bedingung, die hier stuende, koennte niemand pruefen.
 *
 * `werte` ist die EINZIGE Eigenschaft, und sie ist kein Schalter: es sind die Google-Angaben, die
 * die Flaeche gerade anzeigt. Wer die Attribution loswerden will, muss die Angaben loswerden.
 * Die Ratsche in `apps/api/test/google-attribution.test.ts` haelt genau das fest — kommt hier eine
 * zweite Eigenschaft dazu (`versteckt`, `kompakt`, `variante`), wird sie rot.
 */
import { googleAttribution } from "@maestro/google-attribution";

export function GoogleAttribution({ werte }: { werte: readonly unknown[] }) {
  const attribution = googleAttribution({ googleWerte: werte });
  if (!attribution) return null;
  return (
    <p
      className="font-body-sm text-[11px] text-secondary dark:text-secondary-fixed-dim"
      title={attribution.hinweis}
      aria-label={attribution.hinweis}
    >
      {attribution.text}
    </p>
  );
}
